module.exports = __webpack_public_path__ + "img/tab1.f05ab7de.png";